var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import API from "@irati/utils/services/API";
import authentication from "@irati/auth";
import PBService from "@irati/utils/services";
import endpoints from "../endpoints";
import ssoErrorHandler from "./errors/ssoErrorHandler";
var Service = /** @class */ (function (_super) {
    __extends(Service, _super);
    function Service() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getProviderByTenantReference = function (tenant) {
            if (tenant === void 0) { tenant = authentication.userTenant(); }
            return API.get(endpoints.samlProvider() + "/tenant-reference/" + tenant.uuid);
        };
        _this.createSamlIdentityProvider = function (data) {
            return API.post(endpoints.samlProvider() + "/saml", data);
        };
        _this.samlInitiateLogin = function (tenant) {
            return API.get(endpoints.samlProvider() + "/" + tenant.uuid + "/saml/login").then(function (res) { return res.data; });
        };
        _this.deleteSaml = function (tenant) {
            if (tenant === void 0) { tenant = authentication.userTenant(); }
            return API.delete(endpoints.samlProvider() + "/" + tenant.uuid + "/saml");
        };
        _this.idpLogin = function (SAMLResponse) {
            return API.post(endpoints.samlProvider() + "/saml/idp", { SAMLResponse: SAMLResponse }).then(function (res) { return res.data; });
        };
        return _this;
    }
    return Service;
}(PBService));
var service = new Service({ errorHandlers: [ssoErrorHandler] });
export var getProviderByTenantReference = service.getProviderByTenantReference;
export var createSamlIdentityProvider = service.createSamlIdentityProvider;
export var samlInitiateLogin = service.samlInitiateLogin;
export var deleteSaml = service.deleteSaml;
export var idpLogin = service.idpLogin;
export default service;
